import { injectGlobal } from 'emotion';

injectGlobal`
  html,
  body,
  div,
  iframe,
  header,
  footer,
  button,
  form,
  input,
  ul,
  li,
  ol,
  a,
  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    margin: 0;
    padding: 0;
  }

  html {
    background: #F3F5F7;
  }

  .clear {
    clear: both
  }
`;
